module.exports = __webpack_public_path__ + "img/cog-solid.f8354510.svg";